import React, { useMemo } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface ReportGenerationChartProps {
  loading?: boolean;
}

const ReportGenerationChart: React.FC<ReportGenerationChartProps> = ({ loading }) => {
  if (loading) {
    return (
      <div className="h-48 flex items-center justify-center">
        <div className="animate-pulse bg-gradient-to-r from-slate-200 via-slate-300 to-slate-200 w-full h-full rounded-xl"></div>
      </div>
    );
  }

  const reportData = useMemo(() => [
    { type: 'Daily', count: 28, size: 2.4 },
    { type: 'Weekly', count: 12, size: 8.7 },
    { type: 'Monthly', count: 6, size: 15.2 },
    { type: 'Custom', count: 8, size: 5.8 }
  ], []);

  return (
    <div className="w-full h-48 bg-gradient-to-br from-slate-50 to-white rounded-xl border border-slate-200 p-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={reportData}>
          <CartesianGrid strokeDasharray="2 2" stroke="#e2e8f0" opacity={0.3} />
          <XAxis 
            dataKey="type" 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <YAxis 
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 12, fill: '#64748b' }}
          />
          <Tooltip />
          <Bar dataKey="count" fill="#6366f1" radius={[4, 4, 0, 0]} name="Reports Generated" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default ReportGenerationChart;